import styles from './profile-settings.module.scss'
import { ReactNode } from 'react'

interface SocialLinkProps {
  href: string
  children: ReactNode
  className?: string
  onClick?: () => void
}

export const SocialLink = ({ href, children, className = '', onClick }: SocialLinkProps): React.ReactElement => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={`flex items-center justify-center w-5 h-5 transition-colors duration-300 cursor-pointer hover:text-primary ${styles.socialLink} ${className}`}
    >
      {children}
    </a>
  )
}
